/*
 * Head/body split embed loader (W1-20260908-001).
 *
 * Placed in the page <head> via:
 *   <script async src="{api_url}/widgets/v1/loader.js"></script>
 *
 * The widget is mounted where the embedder puts a body placeholder:
 *   <div data-zooza-widget="registration" data-zooza-id="API_KEY"></div>
 *
 * This loader is intentionally dependency-free (no jQuery). It resolves the API
 * host from its own script origin, finds the placeholder(s), and injects the
 * matching widget bundle(s). Each bundle mounts itself into its placeholder
 * (see the mount resolver in profile/init.js and registration/main.js). It runs
 * on DOMContentLoaded — never window.load — so it starts during page parse.
 */
(function () {
    var DEFAULT_HOST = 'https://api.zooza.app';
    var DEFAULT_VERSION = 'v1';

    // The loader is served from /widgets/{version}/loader.js, so derive the
    // version from its own src path — one loader serves both v1 and v2.
    function get_version(src) {
        var m = /\/widgets\/(v\d+)\//.exec(src || '');
        return m ? m[1] : DEFAULT_VERSION;
    }

    // Widget type on the placeholder -> ?type= value served by index.php.
    // (v1 index.php aliases registration_new -> registration; the v1 test
    // harness uses registration_new, so keep the mapping for v1 only.)
    function type_to_query(type, version) {
        if (version === 'v1' && type === 'registration') {
            return 'registration_new';
        }
        return type;
    }

    // document.currentScript is only set while this file evaluates; run() is
    // often deferred to DOMContentLoaded, so capture it now. Without this a
    // page carrying both the v1 and v2 loaders resolves both to whichever
    // loader tag comes last.
    var own_script_src = document.currentScript && document.currentScript.src
        ? document.currentScript.src
        : '';

    // The loader's own <script> src carries the region host (the app bakes it
    // into {api_url}). Prefer the captured currentScript; fall back to scanning
    // for a script whose src looks like this loader.
    function get_own_src() {
        if (own_script_src) {
            return own_script_src;
        }
        var scripts = document.getElementsByTagName('script');
        for (var i = scripts.length - 1; i >= 0; i--) {
            var src = scripts[i].src || '';
            if (/\/widgets\/v1\/(loader\.js|[^\/]*[?&]type=loader)/.test(src) || /loader\.js/.test(src)) {
                return src;
            }
        }
        return '';
    }

    function origin_of(url) {
        try {
            return new URL(url, window.location.href).origin;
        } catch (e) {
            return '';
        }
    }

    // Resolution order (contract, W1-20260908-001):
    //   placeholder data-zooza-api-url -> loader script origin
    //   -> body[data-zooza-api-url] -> default
    function resolve_host(placeholder) {
        var attr = placeholder && placeholder.getAttribute('data-zooza-api-url');
        if (attr) {
            return attr;
        }
        var origin = origin_of(get_own_src());
        if (origin) {
            return origin;
        }
        var body_attr = document.body && document.body.getAttribute('data-zooza-api-url');
        if (body_attr) {
            return body_attr;
        }
        return DEFAULT_HOST;
    }

    function inject_bundle(host, version, type) {
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = host + '/widgets/' + version + '/?type=' + type_to_query(type, version) +
            '&ref=' + encodeURIComponent(window.location.href);
        (document.head || document.documentElement).appendChild(s);
    }

    function run() {
        var placeholders = document.querySelectorAll('[data-zooza-widget]');
        if (!placeholders.length) {
            return;
        }

        var version = get_version(get_own_src());

        // Host is resolved from the loader origin (shared across placeholders);
        // the first placeholder may override via data-zooza-api-url. Set it on
        // <body> so the existing bundle-side resolver (create_api_domain) works
        // unchanged.
        var host = resolve_host(placeholders[0]);
        if (document.body && !document.body.getAttribute('data-zooza-api-url')) {
            document.body.setAttribute('data-zooza-api-url', host);
        }

        var loaded = {};
        for (var i = 0; i < placeholders.length; i++) {
            var type = placeholders[i].getAttribute('data-zooza-widget');
            if (!type || loaded[type]) {
                continue;
            }
            loaded[type] = true;
            inject_bundle(host, version, type);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
    } else {
        run();
    }
})();
